import React, { useState, useEffect } from "react";
import { Menu, X, Home, Info, Users, Calendar, BookOpen, Heart, ChevronRight, Mail } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import styles from "../styles/Header.module.css";
import logo from "../assets/images/churchLogo.png";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const scrolled = scrollTop > 10;
      setIsScrolled(scrolled);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
    } else {
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    };
  }, [menuOpen]);

  const handleMenuToggle = () => {
    if (menuOpen) {
      handleCloseMenu();
    } else {
      setMenuOpen(true);
    }
  };

  const handleCloseMenu = () => {
    setIsClosing(true);
    setTimeout(() => {
      setMenuOpen(false);
      setIsClosing(false);
    }, 280);
  };
  
  const handleNavClick = (path) => {
    handleCloseMenu();
    setTimeout(() => {
      navigate(path);
    }, 280);
  };

  const handleFellowshipClick = () => {
    handleCloseMenu();
    setTimeout(() => {
      navigate("/fellowship");
    }, 280);
  };

  const navItems = [
    { path: "/", label: "Home", icon: Home },
    { path: "/about-us", label: "About Us", icon: Info },
    { path: "/ministry", label: "Ministries", icon: Users },
    { path: "/events", label: "Events", icon: Calendar },
    { path: "/sermons", label: "Sermons", icon: BookOpen },
    { path: "/contact-us", label: "Contact Us", icon: Mail },
  ];

  return (
    <>
      <header className={`${styles.header} ${isScrolled ? styles.headerScrolled : ''}`}>
        <div className={styles.container}>
          <div className={styles.headerContent}>
            <div className={styles.logo}>
              <img src={logo} alt="Church Logo" className={styles.logoImage} />
              <span className={styles.logoTextFull}>C.W.F.M</span>
              <span className={styles.logoTextShort}>CWF</span>
            </div>

            <nav className={styles.navWrapper}>
              <ul className={styles.nav}>
                {navItems.filter(item => item.label !== "Contact Us").map((item) => (
                  <li key={item.path}>
                    <Link to={item.path} className={styles.navLink}>
                      {item.label}
                    </Link>
                  </li>
                ))}
                <li>
                  <Link to="/contact-us" className={`${styles.navLink} ${styles.contactUsNav}`}>
                    Contact Us
                  </Link>
                </li>
              </ul>
            </nav>

            <div className={styles.actions}>
              <div className={styles.buttonGroup}>
                <button
                  className={styles.visitBtn}
                  onClick={handleFellowshipClick}
                >
                  FELLOWSHIP WITH US
                </button>
              </div>

              <button
                onClick={handleMenuToggle}
                className={`${styles.menuBtn} ${menuOpen ? styles.menuBtnActive : ''}`}
                aria-label="Toggle menu"
              >
                <span className={styles.menuIconWrapper}>
                  <Menu className={`${styles.menuIcon} ${menuOpen ? styles.menuIconHidden : ''}`} size={22} />
                  <X className={`${styles.closeIcon} ${menuOpen ? styles.closeIconVisible : ''}`} size={22} />
                </span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {menuOpen && (
        <div className={styles.mobileMenuWrapper}>
          <div 
            className={`${styles.overlay} ${isClosing ? styles.overlayClosing : ''}`} 
            onClick={handleCloseMenu}
          />
          
          <div className={`${styles.mobileMenu} ${isClosing ? styles.mobileMenuClosing : ''}`}>
            <div className={styles.mobileMenuHandle}>
              <div className={styles.handleBar}></div>
            </div>

            <nav className={styles.mobileNav}>
              <ul className={styles.mobileNavList}>
                {navItems.map((item, index) => {
                  const IconComponent = item.icon;
                  return (
                    <li 
                      key={item.path} 
                      className={styles.mobileNavItem}
                      style={{ animationDelay: `${index * 0.04}s` }}
                    >
                      <button
                        onClick={() => handleNavClick(item.path)}
                        className={styles.mobileNavLink}
                      >
                        <span className={styles.mobileNavIconWrapper}>
                          <IconComponent size={16} className={styles.mobileNavIcon} />
                        </span>
                        <span className={styles.mobileNavLabel}>{item.label}</span>
                        <ChevronRight size={16} className={styles.mobileNavArrow} />
                      </button>
                    </li>
                  );
                })}
              </ul>
            </nav>

            <div className={styles.mobileMenuFooter}>
              <button
                className={styles.mobileVisitBtn}
                onClick={handleFellowshipClick}
              >
                <Heart size={14} className={styles.fellowshipIcon} />
                <span>Fellowship With Us</span>
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={styles.spacer} />
    </>
  );
}